import { rd } from '@passionware/monads';
import { rowLevelValidation } from 'v5/platform/row-level-validation';
import {
  withWorkspaceScoping,
  workspaceScopingQueryUtils
} from 'v5/api/_common/query/workspace-scoping';
import type { AppScopeIdentity } from 'v5/core/app-scope/appScope.types';
import { resourceDisplayName } from 'v5/patterns/resource/resourceDisplayName';
import { RESOURCE_CORE_FIELD_ICONS } from 'v5/patterns/resource/resourceFieldIcons';
import { FilterEnumConfig } from 'v5/patterns/filters/FilterWidget.types';
import { MergeServices } from 'v5/platform/ts/services';
import { WithMetastructureMappingService } from 'v5/services/internal/MetastructureMappingService/MetastructureMappingService';
import { WithResourceTypeService } from 'v5/services/internal/ResourceTypeService/ResourceTypeService';
import { WithResourceService } from 'v5/services/io/ResourceService/ResourceService';
import { WithTagService } from 'v5/services/io/TagsService/TagsService';
import { WithGroupsService } from 'v5/services/io/GroupsService/GroupsService';

export function createAgentFilterConfig(
  services: MergeServices<
    [
      WithMetastructureMappingService,
      WithResourceTypeService,
      WithResourceService,
      WithTagService,
      WithGroupsService
    ]
  >,
  scope: AppScopeIdentity
): FilterEnumConfig<string> {
  return {
    label: 'Agent',
    icon: <RESOURCE_CORE_FIELD_ICONS.represented_by_id />,
    type: 'enum',
    createDefaultValue: () => ({ operator: 'matchAny', value: [] as string[] }),
    options: {
      useValues: (values: string[]) =>
        rd.useLastWithPlaceholder(
          rd.map(
            services.resourceService.useItemsById(values.map(Number)),
            resources =>
              resources.map(resource => ({
                value: resource.id.toString(),
                label: resourceDisplayName(resource)
              }))
          )
        ),
      useOptions: (query: string) =>
        rd.useLastWithPlaceholder(
          rd.map(
            services.resourceService.useList(
              withWorkspaceScoping(
                {
                  search: query,
                  filters: {
                    resource_type_model: {
                      operator: 'matchAny',
                      value: ['AGENT']
                    }
                  },
                  page: { pageSize: 50, page: 0 },
                  sort: { field: 'full_name', order: 'asc' }
                },
                workspaceScopingQueryUtils.fromScope(scope)
              )
            ),
            resources =>
              rowLevelValidation
                .validDataFromRows(resources.items)
                .map(resource => ({
                  value: resource.id.toString(),
                  label: resourceDisplayName(resource)
                }))
          )
        )
    }
  };
}
